
export default {
    namespaced: true,
    state:{
        url:'https://xgzh3.oss-cn-hangzhou.aliyuncs.com/'
    },
    getters: {
        uploadurl(state){
            return  state.url
        }
    }
}